import { LDFlagSet } from 'launchdarkly-js-client-sdk';
import { Channel } from 'basics/enums/maya.enums';
import { SelectOption } from 'basics/options/options.types';

const channelsOptions = (flags?: LDFlagSet, currentChannel?: Channel | undefined) => {
  const oneToOneChannels = [Channel.oneToOneDropMaterial, Channel.oneToOneIVA, Channel.oneToOneKeyMessage];
  const enableOneToOneDefaultChannel = !flags?.mayaAkma550EnableOneToOneTacticChannels || currentChannel === Channel.oneToOne;
  const currentChannelIsOneToOneType = currentChannel && oneToOneChannels.includes(currentChannel);
  const enableExtendedOneToOneChannels = flags?.mayaAkma550EnableOneToOneTacticChannels || currentChannelIsOneToOneType;

  const options: SelectOption[] = [
    { id: Channel.approvedEmail, label: 'Approved eMail' },
    { id: Channel.broadcastEmail, label: 'Broadcast eMail' },
    { id: Channel.f2fEvent, label: 'F2F Event' },
    { id: Channel.f2fMeeting, label: 'F2F Meeting' },
    { id: Channel.hybridEvent, label: 'Hybrid Event' },
    { id: Channel.telephone, label: 'Telephone' },
    { id: Channel.virtualEvent, label: 'Virtual Event' },
    { id: Channel.virtualMeeting, label: 'Virtual Meeting' },
    { id: Channel.webLogIn, label: 'Web login' },
    { id: Channel.webNoLogIn, label: 'Web no login' },
    ...(enableOneToOneDefaultChannel ? [{ id: Channel.oneToOne, label: '1:1' }] : []),
    ...(enableExtendedOneToOneChannels ? [{ id: Channel.oneToOneDropMaterial, label: '1:1 with Drop Material' }] : []),
    ...(enableExtendedOneToOneChannels
      && flags?.mayaAkma382EnableIvaTacticField ? [{ id: Channel.oneToOneIVA, label: '1:1 with IVA' }] : []),
    ...(enableExtendedOneToOneChannels ? [{ id: Channel.oneToOneKeyMessage, label: '1:1 with Key Message' }] : []),
  ];

  return options;
};

export default channelsOptions;

